import { BrowserRouter } from "react-router";

import { Toaster } from "./components/ui/toaster.tsx";
import { CustomerApplication } from "./customer-application";
import { AuthenticationProvider } from "./app/auth/authentication-provider";

export const AppBase: React.FC = () => {
  return (
    <>
      <AuthenticationProvider>
        <BrowserRouter>
          <CustomerApplication />
        </BrowserRouter>
      </AuthenticationProvider>
      <Toaster />
    </>
  );
};
